// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
var Shopify = Shopify || {}
Shopify.money_format = document.querySelector(".price-container__format")?.innerText
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.','') }
  let value = ''
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
      formatString = (format || this.money_format)

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt)
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2)
    thousands = defaultOption(thousands, ',')
    decimal   = defaultOption(decimal, '.')

    if (isNaN(number) || number == null) { return 0 }

    number = (number/100.0).toFixed(precision)

    const parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : ''

    return dollars + cents
  }

  if (formatString) {
    const match = formatString.match(placeholderRegex)
    if (match) {
      switch(match[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2)
          break
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0)
          break
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',')
          break
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',')
          break
      }
    }
  }

  return formatString ? formatString.replace(placeholderRegex, value) : ''
}

window.app = {
  productPage: {
    init: function() {
      const option_select = document.querySelectorAll(".product-hero__pack-selector__option")
      window.app.productPage.variants = this.parseVariantData(JSON.parse(document.querySelector('.product-hero [variants-data]').textContent))

      // Initialize variant selector
      option_select.forEach(item => {
  item.addEventListener('click', event => {
    event.preventDefault()

    if (item && !item.classList.contains('active')) {
      const option_select_type = item.dataset.type
      const activeItem = document.querySelector(`[data-type="${option_select_type}"].active`)
      if (activeItem) {
        activeItem.classList.remove('active')
      }
      item.classList.add('active')
      this.changeVariant(item.dataset.variant)
    }
  })
})

      // Initialize Add to Cart button
      const atcButton = document.querySelector('.product-hero__form__submit')
      atcButton?.addEventListener('click', event => {
        event.preventDefault()
        this.addToCart(atcButton.hasAttribute('in-cart'))
      })
      this.quantitySelector()
      this.stickyAddToCart()
      this.specsTabs()
    },
    parseVariantData: variantsData => {
      let parsedData = []

      for (i=0; i < variantsData.length; i++) {
        parsedData[i] = {...variantsData[i].data, ...variantsData[i].additional, ...variantsData[i].metafields}
      }

      return parsedData
    },
    addToCart: (redirect = false) => {
      if (redirect) {
        window.location.href = "/cart"
        return
      }

      window.app.productPage.lockCart()
      const variantId = document.querySelector('.product-hero__form form input[name=id]').value
      const formData = {
        'items': [{
          'id': variantId,
          'quantity': 1
        }]
      }

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => response.json())
      .then(data => {
        if (data.items) {
          const variantIndex = window.app.productPage.variants.findIndex(variant => variant.id == variantId)
          window.app.productPage.variants[variantIndex].already_in_cart = data.items[0].quantity
          window.app.productPage.updateCartBubble('increase', 1)
        }
        window.app.productPage.updateHero(variantId)
        window.app.productPage.unlockCart()
      })
      .catch(error => {
        console.error('Something went wrong.', error)
      })
    },
    changeQuantity: quantity => {
      window.app.productPage.lockCart()

      const variantId = document.querySelector('.product-hero__form form input[name=id]').value
      const formData = {
        updates: {}
      }
      formData.updates[variantId] = quantity

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => response.json())
      .then(data => {
        const variantIndex = window.app.productPage.variants.findIndex(variant => variant.id == variantId)
        const filteredItem = data.items.filter(item => item.id == variantId)[0]
        if (filteredItem) {
          window.app.productPage.variants[variantIndex].already_in_cart = filteredItem.quantity
        } else if (quantity <= 0) {
          window.app.productPage.variants[variantIndex].already_in_cart = quantity
        }
        window.app.productPage.updateCartBubble('replace', data.item_count)
        window.app.productPage.updateHero(variantId)
        window.app.productPage.unlockCart()
      })
      .catch(error => {
        console.error('Something went wrong.', error)
      })

    },
    quantitySelector: () => {
      const quantitySelector = document.querySelector('.product-hero__form__quantity')
      if (!quantitySelector) return
    
      const quantityInput = quantitySelector.querySelector('input')
      const btnDecrease = quantitySelector.querySelector('[data-button-decrease]')
      const btnIncrease = quantitySelector.querySelector('[data-button-increase]')
      const inputEvent = new Event('input')
    
      btnIncrease.addEventListener('click', () => {
        Number(quantityInput.value) < Number(quantityInput.max) && (quantityInput.value = Number(quantityInput.value) + 1)
        quantityInput.dispatchEvent(inputEvent)
      })
      btnDecrease.addEventListener('click', () => {
        Number(quantityInput.value) > 0 && (quantityInput.value = Number(quantityInput.value) - 1)
        quantityInput.dispatchEvent(inputEvent)
      })
    
      quantityInput.addEventListener('input', debounce(() => {
        window.app.productPage.changeQuantity(Number(quantityInput.value))
      }, 700))
    },
    stickyAddToCart: () => {
      const stickyAtcBar = document.querySelector('.product-hero__sticky-atc')
      const heroPostition = document.querySelector('.product-hero-section').offsetHeight
      window.pageYOffset > heroPostition ? stickyAtcBar.classList.add('is-visible') : stickyAtcBar.classList.remove('is-visible')

      document.addEventListener('scroll', event => {
        window.pageYOffset > heroPostition ? stickyAtcBar.classList.add('is-visible') : stickyAtcBar.classList.remove('is-visible')
      })

      const stickyOptionSelectors = stickyAtcBar.querySelectorAll('select')
      stickyOptionSelectors.forEach(select => {
        select.addEventListener('change', () => {
          if (select.classList.contains('product-hero__sticky-atc__fit-selector')) {
            stickyOptionSelectors.forEach(item => item.setAttribute("disabled", true))
            window.location.href = select.options[select.selectedIndex].dataset.url
          } else {
            window.app.productPage.changeVariant(select.value)
          }
        })
      })

      const stickyAtcButton = stickyAtcBar.querySelector('button')
      stickyAtcButton.addEventListener('click', event => {
        event.preventDefault()
        window.app.productPage.addToCart(stickyAtcButton.hasAttribute('in-cart'))
      })

    },
    lockCart: () => {
      const variantOptions = document.querySelectorAll('.variant-option')
      variantOptions.forEach(item => item.classList.add('disabled'))

      const atcButtons = document.querySelectorAll('.js-atc')
      atcButtons.forEach(button => {
        button.classList.add('loading')
        button.disabled = true
      })

      const quantitySelector = document.querySelector('.product-hero__form__quantity')
      quantitySelector.classList.add('disabled')
    },
    unlockCart: () => {
      const variantOptions = document.querySelectorAll('.variant-option')
      variantOptions.forEach(item => item.classList.remove('disabled'))

      const atcButtons = document.querySelectorAll('.js-atc')
      atcButtons.forEach(button => {
        button.classList.remove('loading')
        button.disabled = false
      })

      const quantitySelector = document.querySelector('.product-hero__form__quantity')
      quantitySelector.classList.remove('disabled')
    },
    changeVariant: variantId => {
      // Change URL
      let queryParams = new URLSearchParams(window.location.search)
      queryParams.set('variant', variantId)
      history.pushState(null, null, `?${queryParams}`)

      window.app.productPage.updateHero(variantId)
      window.app.productPage.renderSection(".product-description-section")
      window.app.productPage.renderSection(".product-specs-section")

    },
   updateHero: variantId => {
      const variantData = window.app.productPage.variants.filter(variant => variant.id == variantId)[0]
      const heroElements = {
        title: document.querySelector('.product-hero__content h1'),
        badges: document.querySelector('.product-hero__content .product-badges'),
        price: {
          regularPrice: document.querySelector('.product-hero__content .price-container__current-price'),
          compareAtPrice: document.querySelector('.product-hero__content .price-container__old-price'),
          perPiecePrice: document.querySelector('.product-hero__content .price-container__price-per-piece span'),
          savingPrice: document.querySelector('.product-hero__content .price__saving')
        },
        gallery: {
          thumbnails: document.querySelector('.product-hero__thumbnails'),
          main: document.querySelector('.product-hero__main-carousel')
        },
        form: {
          variantInput: document.querySelector('.product-hero__action form input[name=id]'),
          quantitySelector: document.querySelector('.product-hero__form__quantity'),
          quantityInput: document.querySelector('.product-hero__form__quantity input'),
          button: document.querySelector('.product-hero__form__submit'),
          buttonContent: document.querySelector('.product-hero__form__atc-content')
        },
        stickyAtc: {
          button: document.querySelector('.product-hero__sticky-atc__atc'),
          buttonContent: document.querySelector('.product-hero__sticky-atc__atc__content')
        }
      }

      // Prices
      if (heroElements.price.regularPrice) {
        heroElements.price.regularPrice.innerText = Shopify.formatMoney(variantData.price)
      }
      if (heroElements.price.compareAtPrice) {
        heroElements.price.compareAtPrice.innerText = variantData.compare_at_price > variantData.price ? Shopify.formatMoney(variantData.compare_at_price) : ''
      }
      if (heroElements.price.savingPrice) {
        const savePriceText = heroElements.price.savingPrice.dataset.savedPrice
        const savePricePercentage = 100 * (variantData.compare_at_price - variantData.price) / variantData.compare_at_price
        if (savePricePercentage <= 0 || !savePricePercentage) {
          heroElements.price.savingPrice.classList.add("hidden")
        } else {
          heroElements.price.savingPrice.classList.remove("hidden")
          heroElements.price.savingPrice.innerText = `${savePriceText} ${Shopify.formatMoney(variantData.compare_at_price - variantData.price)} (${savePricePercentage > 0 && savePricePercentage < 1 ? Math.ceil(savePricePercentage) : Math.floor(savePricePercentage)}%)`
        }
      }
      if (heroElements.price.perPiecePrice) {
        heroElements.price.perPiecePrice.innerText = Shopify.formatMoney(variantData.price_per_piece)
      }
      // Badges
      // Discount badge
      const discountBadge = heroElements.badges.querySelector('.product-badges__item--discount')
      variantData.compare_at_price <= variantData.price && discountBadge?.classList.add('is-hidden')
      if (variantData.compare_at_price > variantData.price) {
        const savings = 100 - 100 * variantData.price / variantData.compare_at_price
        const discountBadgeContents = discountBadge?.querySelector('span')
        const contents = discountBadgeContents.innerText.replace(/[0-9]/g,"").replace(/%/, " ")
        discountBadgeContents.innerText = `${contents} ${savings > 0 && savings < 1 ? Math.ceil(savings) : Math.floor(savings)}%`
        discountBadge?.classList.remove('is-hidden')
      }
      // Variant badges
      const variantBadges = heroElements.badges?.querySelectorAll('.product-badges__item--variant');
  if (variantBadges) {
    variantBadges.forEach(item => item.remove());
    if (variantData.variant_badges) {
      variantData.variant_badges.forEach(badge => {
        const badgeData = badge.split(':');
        const badgeItem = document.createElement('div');
        badgeItem.classList.add('product-badges__item', 'product-badges__item--variant');
        badgeItem.style.backgroundColor = badgeData[1];
        badgeItem.style.color = badgeData[2];
        badgeItem.innerHTML = `<span>${badgeData[0]}</span>`;
        heroElements.badges.appendChild(badgeItem);
      });
    }
  }

      // Media carousel
      const hasVariantImage = heroElements.gallery.thumbnails ? heroElements.gallery.thumbnails.querySelector('.swiper-slide--variant') : heroElements.gallery.main.querySelector('.swiper-slide--variant');
  const mainGalleryFirstImage = heroElements.gallery.main.querySelector('.swiper-slide--variant img');
  const thumbGalleryFirstImage = heroElements.gallery.thumbnails ? heroElements.gallery.thumbnails.querySelector('.swiper-slide--variant img') : heroElements.gallery.main.querySelector('.swiper-slide--variant img');

  if (variantData.featured_image && hasVariantImage) {
    mainGalleryFirstImage.parentNode.classList.add('loading');
    thumbGalleryFirstImage.parentNode.classList.add('loading');
    mainGalleryFirstImage.removeAttribute('srcset');
    thumbGalleryFirstImage.src = variantData.featured_image.src;
    mainGalleryFirstImage.src = variantData.featured_image.src;
    thumbGalleryFirstImage.addEventListener('load', () => {
      thumbGalleryFirstImage.parentNode.classList.remove('loading');
    });
    mainGalleryFirstImage.addEventListener('load', () => {
      mainGalleryFirstImage.parentNode.classList.remove('loading');
    });
  }


      // Variant options
      window.app.productPage.updateOptionSelectors(variantData)
      if (heroElements.form.variantInput) {
        heroElements.form.variantInput.value = variantData.id;
      }

      // Custom Url Button
      const customUrlHero = document.getElementById('customUrlButton')
      const customUrlSticky = document.getElementById('customUrlButtonSticky')

      if (customUrlHero && customUrlSticky) {
        const url = variantData.custom_url;
        const isCustomUrl = variantData.custom_url !== null && variantData.custom_url !== undefined;
        const text = isCustomUrl ? heroElements.form.button.dataset.available : heroElements.form.button.dataset.soldout;

        if (isCustomUrl) {
          updateCustomUrlButton(customUrlHero, url, text, "btn--filled-white", "btn--disabled-light");
          updateCustomUrlButton(customUrlSticky, url, text, "btn--filled", "btn--disabled-dark");
        } else {
          updateCustomUrlButton(customUrlHero, url, text, "btn--disabled-light", "btn--filled-white");
          updateCustomUrlButton(customUrlSticky, url, text, "btn--disabled-dark", "btn--filled");
        }
      }

      function updateCustomUrlButton(button, href, text, addClass, removeClass) {
        button.href = href;
        button.classList.remove(removeClass);
        button.classList.add(addClass);
        button.innerText = text;

        if (addClass.includes("btn--filled") && !button.hasAttribute("rel")) {
          button.setAttribute("rel", "noopener noreferrer");
          button.classList.remove("button-disabled");
        } else if (addClass.includes("btn--disabled") && button.hasAttribute("rel")) {
          ['rel', 'href'].forEach(attribute => button.removeAttribute(attribute));
          button.classList.add("button-disabled");
        }
      }

      function getButtonState(variantData, elementKey) {
        const props = {
          'form': {
              add: ['btn--filled', 'btn--filled-white'],
              remove: ['btn--disabled-light', 'btn--disabled-dark'],
              content: {
                  in_cart: `${variantData.already_in_cart} ${heroElements.form.button?.dataset.inBasket || ''}`,
                  available: `${heroElements.form.button?.dataset.available || ''} - ${Shopify.formatMoney(variantData.price)}`,
                  disabled: heroElements.form.button?.dataset.soldout || ''
              }
          },
          'stickyAtc': {
              add: ['btn--filled'],
              remove: ['btn--disabled-dark'],
              content: {
                  in_cart: `${variantData.already_in_cart} ${heroElements.stickyAtc.button?.dataset.inBasket || ''}`,
                  available: `${heroElements.stickyAtc.button?.dataset.available || ''} - ${Shopify.formatMoney(variantData.price)}`,
                  disabled: heroElements.stickyAtc.button?.dataset.soldout || ''
              }
          }
      };

        // Start with the class information
        let state = {
            classToAdd: props[elementKey].add,
            classToRemove: props[elementKey].remove
        };

        // Build up the state based on variantData conditions
        if (variantData.already_in_cart) {
          state.disabled = false;
          state.text = props[elementKey].content.in_cart
          state.inCart = true;
      } else if (variantData.available && !variantData.stock.override) {
          state.disabled = false;
          state.text = props[elementKey].content.available
      } else {
          state.disabled = true;
          state.text = props[elementKey].content.disabled
      }

        return {
          elementKey,
          state
        };
      }

      function updateButton(element, buttonState) {
        const { state, elementKey } = buttonState;
        const { button, buttonContent } = element;
      
        if (button && buttonContent) {
          button.classList.remove(...state.classToRemove);
          button.classList.add(...state.classToAdd);
          button.disabled = state.disabled;
          button.setAttribute("aria-disabled", String(state.disabled));
      
          if (state.inCart) {
            button.setAttribute('in-cart', state.inCart);
      
            if (elementKey === 'form') {
              heroElements.form.quantitySelector.classList.add('is-visible');
              heroElements.form.quantityInput.value = variantData.already_in_cart;
            }
          } else {
            button.removeAttribute('in-cart');
            if (elementKey === 'form') heroElements.form.quantitySelector.classList.remove('is-visible');
          }
      
          buttonContent.innerText = state.text;
        } else {
          console.error('Button or button content element is null');
        }
      }

      const formButtonState = getButtonState(variantData, 'form');
      updateButton(heroElements.form, formButtonState);

      const stickyAtcButtonState = getButtonState(variantData, 'stickyAtc');
      updateButton(heroElements.stickyAtc, stickyAtcButtonState);
    },
    updateOptionSelectors: selectedVariant => {
      const packsizeVariants = window.app.productPage.variants.filter(variant => variant[variant.girth] == selectedVariant[selectedVariant.girth])
      const packOptionElements = document.querySelectorAll('.product-hero__pack-selector .variant-option')

      packOptionElements.forEach(item => {
        const packData = packsizeVariants.filter(variant => variant[variant.packsize] == item.dataset.value)[0]

        item.dataset.variant == selectedVariant.id ? item.classList.add('active') : item.classList.remove('active')

        // Update element
        if (packData) {
          item.href = window.location.pathname + '?variant=' + packData.id
          item.dataset.variant = packData.id
          const priceElement = item.querySelector('span.pack-prices__price');
          const pricePerElement = item.querySelector('span.pack-prices__price-per');
          if (priceElement) priceElement.innerText = Shopify.formatMoney(packData.price);
          if (pricePerElement) pricePerElement.innerText = Shopify.formatMoney(packData.price_per_piece);
          item.classList.remove('unavailable')
        } else {
          item.href = ""
          item.dataset.variant = ""
          const priceElement = item.querySelector('span.pack-prices__price');
          const pricePerElement = item.querySelector('span.pack-prices__price-per');
          if (priceElement) priceElement.innerText = Shopify.formatMoney(0);
          if (pricePerElement) pricePerElement.innerText = Shopify.formatMoney(0);
          item.classList.add('unavailable')
        }
      })

      const stickyPackOptionSelector = document.querySelector('.product-hero__sticky-atc__pack-selector')
const stickyPackOptionElements = stickyPackOptionSelector?.querySelectorAll('option')

if (stickyPackOptionSelector) {
  stickyPackOptionSelector.value = selectedVariant.id;
}

stickyPackOptionElements?.forEach(option => {
  const packData = packsizeVariants.filter(variant => variant[variant.packsize] == option.dataset.value)[0]

  // Update element
  if (packData) {
    option.value = packData.id
    option.hidden = false
  } else {
    option.value = ""
    option.hidden = true
  }
})
    },
    renderSection: sectionClass => {
      const section = document.querySelector(sectionClass)
      section.classList.add('loading')
      const sectionId = section.id.replace('shopify-section-', '')
      const queryParams = new URLSearchParams(window.location.search)
      queryParams.set('sections', sectionId)

      fetch(window.location.pathname + '?' + queryParams)
      .then(response => response.json())
      .then(data => {
        section.classList.remove('loading')
        if (data[sectionId] != null) {
          const parser = new DOMParser()
          const updatedSection = parser.parseFromString(data[sectionId], 'text/html')
          section.replaceWith(updatedSection.body.childNodes[0])
        }
      })
    },
    specsTabs: () => {
      const specTabs = document.querySelector('.product-specs__tabs')
      const specLists = document.querySelectorAll('.product-specs__list--bundle')
      if (!specTabs || specLists.length == 0) return

      const specItems = specTabs.querySelectorAll('a')
      specItems.forEach(item => {
        item.addEventListener('click', event => {
          event.preventDefault()

          document.querySelector(`.product-specs__list--bundle.is-active`).classList.remove('is-active', 'is-visible')
          document.querySelector('.product-specs__tabs a.is-active').classList.remove('is-active')
          document.querySelector(`.product-specs__list--bundle[data-product=${ CSS.escape(item.dataset.product) }]`).classList.add('is-active')
          item.classList.add('is-active')
          setTimeout(() => {
            document.querySelector(`.product-specs__list--bundle[data-product=${ CSS.escape(item.dataset.product) }]`).classList.add('is-visible')
          },10)
        })
      })
    },
    updateCartBubble: (action, quantity) => {
      const cartBubble = document.querySelector('.cart-count-bubble')
      if (!cartBubble) return

      const countBubble = cartBubble.querySelector('span.count-bubble')
      const countAria = cartBubble.querySelector('span.visually-hidden')

      const oldQuantity = Number(countBubble.innerText)
      if (action === 'increase') quantity += oldQuantity

      countBubble.innerText = String(quantity)
      countAria.innerHTML = countAria.innerHTML.replace(String(oldQuantity), String(quantity))

      if (countBubble.innerText === '0') cartBubble.style.display = "none";
      else cartBubble.style.display = "flex";

      cartBubble.classList.toggle('visually-hidden', quantity >= 100)
    }
  }
}

window.addEventListener('DOMContentLoaded', () => {
  window.app.productPage.init()
})